module.exports = __webpack_public_path__ + "static/media/MaqTejMin2.42264a9a.jpg";